import React from 'react';
import PropTypes from 'prop-types';
import { isFunction } from 'lodash';
import Validation from '../../Validation/Validation';
import MainTextField from '../../MUI/MainTextField';

const TextInputFieldWithValidation = (props) => {
  const {
    formProps,
    labelKey,
    name,
    value,
    placeholder,
    handleChange,
    disabled,
    maxLength,
    autoComplete,
    register,
    onPaste,
    required,
    type,
    multiline,
    minRows,
    InputLabelProps,
    InputProps,
  } = props;
  const { errors, clearError } = formProps;

  const commonProps = {
    id: name,
    variant: 'outlined',
    fullWidth: true,
    type,
    size: 'small',
    name,
    placeholder,
    label: labelKey,
    required,
    disabled,
    onPaste,
    autoComplete,
    ...(isFunction(handleChange) && { onChange: handleChange }),
    ...(maxLength && { maxLength }),
    multiline,
    minRows,
    InputLabelProps,
    InputProps,
  };

  return (
    <Validation name={name} errors={errors} clearError={clearError}>
      {isFunction(register) ? (
        <MainTextField inputRef={register} {...commonProps} />
      ) : (
        <MainTextField value={value} {...commonProps} />
      )}
    </Validation>
  );
};

TextInputFieldWithValidation.propTypes = {
  formProps: PropTypes.shape({
    errors: PropTypes.shape({}),
    clearError: PropTypes.func,
  }).isRequired,
  labelKey: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  handleChange: PropTypes.func,
  disabled: PropTypes.bool,
  maxLength: PropTypes.number,
  autoComplete: PropTypes.string,
  register: PropTypes.func,
  required: PropTypes.bool,
  onPaste: PropTypes.func,
  type: PropTypes.string,
  multiline: PropTypes.bool,
  minRows: PropTypes.number,
  InputLabelProps: PropTypes.shape({}),
  InputProps: PropTypes.shape({}),
};

TextInputFieldWithValidation.defaultProps = {
  value: '',
  placeholder: '',
  handleChange: null,
  disabled: false,
  maxLength: null,
  autoComplete: 'on',
  register: null,
  required: false,
  type: 'text',
  onPaste: () => {},
  labelKey: '',
  multiline: false,
  minRows: 0,
  InputLabelProps: {},
  InputProps: {},
};

export default TextInputFieldWithValidation;
